export default __webpack_public_path__ + "0233e55af37014ca86c2a75074c9499b.png";